<div class="qa-codes">
	<app-rc-qa-codes [rules]="rules"></app-rc-qa-codes>
</div>
<div class="qa-content">
	<!-- <div *ngIf="isRelativePosConsistentWithDirection" class="tool-buttons">
		<div *ngIf="!isLeftError">
			<mat-icon svgIcon="icon-chevron-left" (click)="jointChange('decrease', 'left')"></mat-icon>
			<mat-icon svgIcon="icon-chevron-right" (click)="jointChange('increase', 'left')"></mat-icon>
		</div>
		<div *ngIf="isLeftError">
			<mat-icon svgIcon="icon-chevron-last-right" (click)="attachToLarger('left')"></mat-icon>
			<mat-icon svgIcon="icon-chevron-last-left" (click)="attachToLower('left')"></mat-icon>
		</div>
	</div> -->
	<div class="centerline-list-wrap" [ngClass]="{
		'relative-position-LR': relativePosition === 'leftRight',
		'relative-position-UL': relativePosition === 'upperLower',
		'relative-pos-inconsistent': !isRelativePosConsistentWithDirection}">
		<div class="centerline-list" [ngClass]="{'roads-connected': isRoadsConnected}">
			<div *ngIf="firstEndConnected" class="connected-line connected-line-first"></div>
			<div class="centerline-item" *ngFor="let centerline of centerlineList; let idx = index" [ngClass]="{'centerline-item-horizontal': centerline.horizontalVertical==='hori'}" [ngSwitch]="centerline.direction">
				<app-rc-road-direction
					[centerlineDirection]="centerline.direction"
					[fromAddrLeftCol]="fromAddrLeftCol"
					[toAddrLeftCol]="toAddrLeftCol"
					[fromAddrRightCol]="fromAddrRightCol"
					[toAddrRightCol]="toAddrRightCol"
					[centerline]="centerline"
					[centerlineIdx]="idx"
					[isRelativePosConsistentWithDirection]="isRelativePosConsistentWithDirection"
					[isLinesDirectionSame]="centerlineList[0].direction===centerlineList[1].direction"
					[isCurrentRoad]="centerline.id === currentId"
					[connectedEnd]="connectedEnd"
					(edit)="onEdit(idx, $event)"
					(attach)="attach($event)"
					(flipFromTo)="flipFromTo($event)"
					(jointChange)="jointChange($event)">
				</app-rc-road-direction>
			</div>
			<div *ngIf="secondEndConnected" class="connected-line connected-line-second"></div>
		</div>
	</div>
	<!-- <div class="tool-buttons">
		<div *ngIf="!isRightError">
			<mat-icon svgIcon="icon-chevron-left" (click)="jointChange('decrease', 'right')"></mat-icon>
			<mat-icon svgIcon="icon-chevron-right" (click)="jointChange('increase', 'right')"></mat-icon>
		</div>
		<div *ngIf="isRightError">
			<mat-icon svgIcon="icon-chevron-last-right" (click)="attachToLarger('right')"></mat-icon>
			<mat-icon svgIcon="icon-chevron-last-left" (click)="attachToLower('right')"></mat-icon>
		</div>
	</div> -->
</div>

<!-- [ngClass]="{'relative-position-LR': centerline.relativePosition === 'left' || centerline.relativePosition === 'right', 'relative-position-UL': centerline.relativePosition === 'upper' || centerline.relativePosition === 'lower'}" -->